/**
 *
 * VariablesExport
 *
 */

import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { compose } from "redux"
import { Checkbox, Spin } from "antd"
import { ROLE_LEADER } from "utils/constants"
import { isEqual } from "lodash"
import { LOCAL_ACTIVE_ROL } from "../../../../../utils/storage"
import { loadTexts } from "../../../../../utils/i18n"

const SegmentVariables = ({ data, defaultData, onClick }) => {
  // stateless component
  const subTitleGroup = loadTexts("reports_exportables").variablesExport
    .subTitleGroup
  return (
    <div className="ReportsExport-body-variables-segment">
      <b className="title">{subTitleGroup}</b>
      <Checkbox.Group value={defaultData} onChange={(e) => onClick(e)}>
        {data.map((variable, index) => (
          <Checkbox key={`segment-${index}`} value={variable.value}>
            {variable.displayValue}
          </Checkbox>
        ))}
      </Checkbox.Group>
    </div>
  )
}

export class VariablesExport extends React.Component {
  intlVariablesExport = loadTexts("reports_exportables").variablesExport
  constructor(props) {
    super(props)
    this.state = {
      defaultOptions: [],
      defaultSegmentOptions: [],
      showSegmentVariables: true,
      optionSegmentVariables: [
        {
          id: 11,
          show: true,
          displayValue: this.intlVariablesExport.age,
          value: "byAge",
        },
        {
          id: 12,
          show: true,
          displayValue: this.intlVariablesExport.timeCompany,
          value: "byCompanyTime",
        },
        {
          id: 13,
          show: true,
          displayValue: this.intlVariablesExport.gender,
          value: "byGender",
        },
        {
          id: 14,
          show: true,
          displayValue: this.intlVariablesExport.hierarchCategory,
          value: "byCategory",
        },
        {
          id: 15,
          show: true,
          displayValue: this.intlVariablesExport.geographLocation,
          value: "byLocation",
        },
      ],
    }
  }

  changeStatusOption = () => {
    const {
      exportTemplate,
      exportScopeSelect,
      medition_segment,
      exportType,
      exportMeditionLeader,
    } = this.props
    let type = 1
    switch (exportType) {
      case "xlsx":
        if (exportScopeSelect === "all") {
          type = 1
        } else if (isNaN(parseInt(exportScopeSelect, 10))) {
          type = 2
        }
        break
      case "pdf":
        if (exportTemplate.length > 0 && exportTemplate === "table") {
          if (exportScopeSelect === "all") {
            type = 3
          } else {
            type = 4
          }
        } else if (
          exportTemplate.length > 0 &&
          exportTemplate === "presentation" &&
          !exportMeditionLeader
        ) {
          if (exportScopeSelect === "all") {
            type = 5
          } else {
            type = 6
          }
        }
        break
    }
    return type
  }

  render() {
    const { optionSegmentVariables } = this.state
    const {
      defaultSegmentOptions,
      options,
      exportMeditionLeader,
      validateQualitativeComments,
      validateMultiple,
      exportScopeSelect,
      medition_segment,
      exportMedition
    } = this.props
    let defaultOptions = []
    const type = this.changeStatusOption()
    const validateCheckSegment = options[type - 1].values.includes(
      `bySegment${type}`
    )
    const renderQualitativeComments = (value) =>
      validateQualitativeComments && (
        <Checkbox value={value}>
          {" "}
          {this.intlVariablesExport.qualitativeComments}
        </Checkbox>
      )

    const renderMultipleOption = (value) => {

      if(validateMultiple) {
        if(medition_segment){
          if(exportScopeSelect == 'segmento'){
            return (<Checkbox value={value}>Opción múltiple</Checkbox>)
          }
        } else {
          return (<Checkbox value={value}>Opción múltiple</Checkbox>)
        }
      }
    }


    const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()
    // Default options enable when the user discheck all the options , then all variables will checked
    switch (type) {
      case 1: // case xlsx - all organization
        defaultOptions = [
          "byDestinatario1",
          "byDivision1",
          "byDimension1",
          this.props.include_multiple && "byMultipleOption1",
          // "byMultipleOption1",
          "qualitative1",
          ...(this.props.hasEnps?  ["byEnps1"]: []),
          "division1",
          "bySegment1",
        ]
        if (exportMeditionLeader) {
          defaultOptions = [
            "byDestinatario1",
            "byDimension1",
            this.props.include_multiple && "byMultipleOption1",
            "byMultipleOption1",
            "qualitative1",
            "byTeam1",
            "team1",
            "bySegment1",
            "byEnps1"
          ]
        }

        if (exportScopeSelect == "all" && medition_segment == true) {
          defaultOptions = [
            "byDestinatario1",
            "byDimension1",
            ...(this.props.hasEnps?  ["byEnps1"]: []),
            this.props.include_multiple && "byMultipleOption1",
          ]
        }

        return (
          <Fragment>
            <div style={!validateCheckSegment ? { borderRight: "none" } : {}}>
              <Checkbox.Group
                value={
                  options[0].values.length === 0
                    ? defaultOptions
                    : options[0].values
                }
                onChange={(e) =>
                  this.props.onChangeVariable(
                    e.length === 0 ? defaultOptions : e,
                    0
                  )
                }>
                {!validRole({ role: [5] }) && (
                  <Checkbox value="byDestinatario1">
                    Reporte de destinatarios
                  </Checkbox>
                )}
                {exportMeditionLeader ? (
                  <Checkbox value="byTeam1">
                    {this.intlVariablesExport.resultByLeader}
                  </Checkbox>
                ) : (
                  <Checkbox value="byDivision1">
                    {this.intlVariablesExport.resultsByDivision}
                  </Checkbox>
                )}
                <Checkbox value="byDimension1">
                  {this.intlVariablesExport.resulysByDimension}
                </Checkbox>

                {exportScopeSelect == "all" && medition_segment == true
                  ? ""
                  : renderQualitativeComments("qualitative1")}

                {this.props.hasEnps && (
                  <Checkbox value="byEnps1">
                    {exportMedition.id_survey_type == 1 ? this.intlVariablesExport.enpsResult : this.intlVariablesExport.npsResult}
                  </Checkbox>
                )}

                {exportMeditionLeader ? (
                  <Checkbox value="team1">Comparativo por líder</Checkbox>
                ) : exportScopeSelect == "all" && medition_segment == true ? (
                  ""
                ) : (
                  <Checkbox value="division1">
                    {this.intlVariablesExport.divisionComparative}
                  </Checkbox>
                )}
                {exportMeditionLeader &&
                  renderMultipleOption("byMultipleOption1")}
                {exportScopeSelect == "all" && exportMedition?.new_version==0 && medition_segment == true ? (
                  ""
                ) : (
                  <Checkbox value="bySegment1">
                    {this.intlVariablesExport.groupComparative}
                  </Checkbox>
                )}

                {!exportMeditionLeader &&
                  renderMultipleOption("byMultipleOption1")}
              </Checkbox.Group>
            </div>
            {validateCheckSegment &&
              (exportScopeSelect == "all" && exportMedition.new_version==0 && medition_segment == true ? (
                ""
              ) : (
                <SegmentVariables
                  data={optionSegmentVariables}
                  defaultData={defaultSegmentOptions}
                  onClick={this.props.onChangeVariableSegment}
                />
              ))}
          </Fragment>
        )

      case 2: // case xlsx - division / team
        if (exportScopeSelect == "all" && medition_segment == true) {
          return
        }
        defaultOptions = [
          "byDestinatario2",
          "byDivision2",
          "byDimension2",
          // "byMultipleOption2",
          this.props.include_multiple && "byMultipleOption2",
          "qualitative2",
          ...(this.props.hasEnps?  ["byEnps2"]: []),
          "bySegment2",
          "division2",
        ]
        if (exportMeditionLeader) {
          defaultOptions = [
            "byDestinatario2",
            "byTeam2",
            "byDimension2",
            // "byMultipleOption2",
            this.props.include_multiple && "byMultipleOption2",
            "qualitative2",
            ...(this.props.hasEnps?  ["byEnps2"]: []),
          ]
          if (isUserLeader) {
            defaultOptions.push("team2")
          }
        }

        return (
          <Fragment>
            <div style={!validateCheckSegment ? { borderRight: "none" } : {}}>
              <Checkbox.Group
                value={
                  options[1].values.length === 0
                    ? defaultOptions
                    : options[1].values
                }
                onChange={(e) =>
                  this.props.onChangeVariable(
                    e.length === 0 ? defaultOptions : e,
                    1
                  )
                }>
                {!validRole({ role: [5, 6] }) && (
                  <Checkbox value="byDestinatario2">
                    Reporte de destinatarios
                  </Checkbox>
                )}
                {exportMeditionLeader ? (
                  !validRole({ role: [6] }) && (
                    <Checkbox value="byTeam2">Resultado por líder</Checkbox>
                  )
                ) : (
                  <Checkbox value="byDivision2">
                    {this.intlVariablesExport.resultsByDivision}
                  </Checkbox>
                )}
                <Checkbox value="byDimension2">
                  {this.intlVariablesExport.resulysByDimension}
                </Checkbox>
                {exportScopeSelect == "division" && medition_segment == true
                  ? ""
                  : renderQualitativeComments("qualitative2")}
                {this.props.hasEnps && (
                  <Checkbox value="byEnps2">
                    {exportMedition.id_survey_type == 1 ? this.intlVariablesExport.enpsResult : this.intlVariablesExport.npsResult}
                  </Checkbox>
                )}
                {!exportMeditionLeader &&
                  (exportScopeSelect == "division" && exportMedition.new_version==0 &&
                  medition_segment == true ? (
                    ""
                  ) : (
                    <Checkbox value="bySegment2">
                      {this.intlVariablesExport.groupComparative}
                    </Checkbox>
                  ))}
                {!exportMeditionLeader &&
                  (exportScopeSelect == "division" &&
                  medition_segment == true ? (
                    ""
                  ) : (
                    <Checkbox value="division2">
                      {this.intlVariablesExport.divisionComparative}
                    </Checkbox>
                  ))}
                {renderMultipleOption("byMultipleOption2")}
              </Checkbox.Group>
            </div>
            {validateCheckSegment &&
              !exportMeditionLeader &&
              (exportScopeSelect == "division" && exportMedition.new_version==0 && medition_segment == true ? (
                ""
              ) : (
                <SegmentVariables
                  data={optionSegmentVariables}
                  defaultData={defaultSegmentOptions}
                  onClick={this.props.onChangeVariableSegment}
                />
              ))}
          </Fragment>
        )
      case 3: // case pdf - table - all
        defaultOptions = [
          "byDivision3",
          "byDimension3",
          ...(this.props.hasEnps?  ["byEnps3"]: []),
          "qualitative3",
        ]
        if (exportMeditionLeader) {
          defaultOptions = ["byTeam3", "byDimension3", "qualitative3"]
        }
        return (
          <Fragment>
            <div style={{ borderRight: "none" }}>
              <Checkbox.Group
                value={
                  options[2].values.length === 0
                    ? defaultOptions
                    : options[2].values
                }
                onChange={(e) =>
                  this.props.onChangeVariable(
                    e.length === 0 ? defaultOptions : e,
                    2
                  )
                }>
                {exportMeditionLeader ? (
                  <Checkbox value="byTeam3">Resultado por líder</Checkbox>
                ) : (
                  <Checkbox value="byDivision3">
                    {this.intlVariablesExport.resultsByDivision}
                  </Checkbox>
                )}
                <Checkbox value="byDimension3">
                  {this.intlVariablesExport.resulysByDimension}
                </Checkbox>
                {!exportMeditionLeader && this.props.hasEnps && (
                  <Checkbox value="byEnps3">
                    {exportMedition.id_survey_type == 1 ? this.intlVariablesExport.enpsResult : this.intlVariablesExport.npsResult}
                  </Checkbox>
                )}
                {renderQualitativeComments("qualitative3")}
              </Checkbox.Group>
            </div>
          </Fragment>
        )
      case 4: // case pdf - table - division / team
        defaultOptions = [
          "byDivision4",
          "byDimension4",
          ...(this.props.hasEnps?  ["byEnps4"]: []),
          "qualitative4",
        ]
        if (exportMeditionLeader) {
          defaultOptions = ["byDimension4", "qualitative4"]
          if (isUserLeader) {
            defaultOptions.push("byTeam4")
          }
        }
        return (
          <Fragment>
            <div style={{ borderRight: "none" }}>
              <Checkbox.Group
                value={
                  options[3].values.length === 0
                    ? defaultOptions
                    : options[3].values
                }
                onChange={(e) =>
                  this.props.onChangeVariable(
                    e.length === 0 ? defaultOptions : e,
                    3
                  )
                }>
                {!exportMeditionLeader && (
                  <Checkbox value="byDivision4">
                    {this.intlVariablesExport.resultsByDivision}
                  </Checkbox>
                )}
                <Checkbox value="byDimension4">
                  {this.intlVariablesExport.resulysByDimension}
                </Checkbox>
                {!exportMeditionLeader && this.props.hasEnps && (
                  <Checkbox value="byEnps4">
                    {exportMedition.id_survey_type == 1 ? this.intlVariablesExport.enpsResult : this.intlVariablesExport.npsResult}
                  </Checkbox>
                )}
                {renderQualitativeComments("qualitative4")}
                {exportMeditionLeader && isUserLeader && (
                  <Checkbox value="byTeam4">Resultado por líder</Checkbox>
                )}
              </Checkbox.Group>
            </div>
          </Fragment>
        )
      case 5: // case pdf - all presentation
        defaultOptions = [
          "tmpIntroduction5",
          "tmpSummary5",
          "tmpMeasureModel5",
          "tmpMeasureMethodology5",
          "tmpAllResult5",
          ...(this.props.hasEnps?  ["byEnps5"]: []),
          "byDimension5",
          "division5",
          "bySegment5",
          "conclusions5",
        ]
        return (
          <Fragment>
            <div style={!validateCheckSegment ? { borderRight: "none" } : {}}>
              <Checkbox.Group
                value={
                  options[4].values.length === 0
                    ? defaultOptions
                    : options[4].values
                }
                onChange={(e) =>
                  this.props.onChangeVariable(
                    e.length === 0 ? defaultOptions : e,
                    4
                  )
                }>
                <Checkbox value="tmpIntroduction5">
                  {this.intlVariablesExport.theoreticalIntro}
                </Checkbox>
                <Checkbox value="tmpSummary5">
                  {this.intlVariablesExport.executiveSummary}
                </Checkbox>
                <Checkbox value="tmpMeasureModel5">
                  {this.intlVariablesExport.measureModel}
                </Checkbox>
                <Checkbox value="tmpMeasureMethodology5">
                  {this.intlVariablesExport.measureMethodology}
                </Checkbox>
                <Checkbox value="tmpAllResult5">
                  {this.intlVariablesExport.generalResults}
                </Checkbox>
                {this.props.hasEnps && (<Checkbox value="byEnps5">
                  {exportMedition.id_survey_type == 1 ? this.intlVariablesExport.enpsResult : this.intlVariablesExport.npsResult}
                </Checkbox>)}
                <Checkbox value="byDimension5">
                  {this.intlVariablesExport.resulysByDimension}
                </Checkbox>
                <Checkbox value="division5">Resultado por division</Checkbox>
                <Checkbox value="bySegment5">
                  {this.intlVariablesExport.groupComparative}{" "}
                </Checkbox>
                <Checkbox value="conclusions5">
                  {this.intlVariablesExport.conclusions}
                </Checkbox>
              </Checkbox.Group>
            </div>
            {validateCheckSegment && (
              <SegmentVariables
                data={optionSegmentVariables}
                defaultData={defaultSegmentOptions}
                onClick={this.props.onChangeVariableSegment}
              />
            )}
          </Fragment>
        )
      case 6: // case pdf - all presentation
        defaultOptions = [
          "tmpIntroduction6",
          "tmpSummary6",
          "tmpMeasureModel6",
          "tmpMeasureMethodology6",
          "tmpAllResult6",
          ...(this.props.hasEnps?  ["byEnps6"]: []),
          "byDimension6",
          "bySegment6",
          "conclusions6",
        ]
        return (
          <Fragment>
            <div style={!validateCheckSegment ? { borderRight: "none" } : {}}>
              <Checkbox.Group
                value={
                  options[5].values.length === 0
                    ? defaultOptions
                    : options[5].values
                }
                onChange={(e) =>
                  this.props.onChangeVariable(
                    e.length === 0 ? defaultOptions : e,
                    5
                  )
                }>
                <Checkbox value="tmpIntroduction6">
                  {this.intlVariablesExport.theoreticalIntro}
                </Checkbox>
                <Checkbox value="tmpSummary6">
                  {this.intlVariablesExport.executiveSummary}
                </Checkbox>
                <Checkbox value="tmpMeasureModel6">
                  {this.intlVariablesExport.measureModel}
                </Checkbox>
                <Checkbox value="tmpMeasureMethodology6">
                  {this.intlVariablesExport.measureMethodology}
                </Checkbox>
                <Checkbox value="tmpAllResult6">
                  {this.intlVariablesExport.generalResults}
                </Checkbox>
                { this.props.hasEnps && (<Checkbox value="byEnps6">
                  {exportMedition.id_survey_type == 1 ? this.intlVariablesExport.enpsResult : this.intlVariablesExport.npsResult}
                </Checkbox>)}
                <Checkbox value="byDimension6">
                  {this.intlVariablesExport.resulysByDimension}
                </Checkbox>
                <Checkbox value="bySegment6">
                  {this.intlVariablesExport.groupComparative}{" "}
                </Checkbox>
                <Checkbox value="conclusions6">
                  {this.intlVariablesExport.conclusions}
                </Checkbox>
              </Checkbox.Group>
            </div>
            {validateCheckSegment && (
              <SegmentVariables
                data={optionSegmentVariables}
                defaultData={defaultSegmentOptions}
                onClick={this.props.onChangeVariableSegment}
              />
            )}
          </Fragment>
        )
    }
  }
}

VariablesExport.propTypes = { dispatch: PropTypes.func.isRequired }

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(VariablesExport)
